export function getTimeTable(){

    // const myButton = document.getElementById("timeTableButton");
    const locname = document.getElementById("locationname");
    const e1 = document.getElementById("prayer-element-1");
    const e2 = document.getElementById("prayer-element-2");
    const e3 = document.getElementById("prayer-element-3");
    const e4 = document.getElementById("prayer-element-4");
    const e5 = document.getElementById("prayer-element-5");
    const e6 = document.getElementById("prayer-element-6");
    const e7 = document.getElementById("prayer-element-7");
    const e8 = document.getElementById("prayer-element-8");

    // myButton.style.visibility ="hidden";

    var resultsArray = [];
    const myDate = new Date();
    var data = [];

    var apiUrl = `https://api.aladhan.com/v1/calendar?latitude=29.34070564164084&longitude=47.94011498254232&method=8&month=${myDate.getUTCMonth()+1}&year=${myDate.getFullYear()}`;

    async function getTime() {
        try {
            const response = await fetch('https://api.db-ip.com/v2/free/self');
            const location = await response.json();
            locname.textContent = `${location.countryName}`;

            apiUrl = `https://api.aladhan.com/v1/calendarByCity?city=${location.city}&country=${location.countryName}&method=8&month=${myDate.getUTCMonth()+1}&year=${myDate.getFullYear()}`
            console.log('second path',apiUrl);
        } catch (error){
            //Catch Error Here
        } 
        //fetch the time
        try {
            const response = await fetch(apiUrl);
            resultsArray = await response.json();
            console.log(resultsArray);
        } catch (error){
            //Catch Error Here
        } 
        ///add DOM items to page
        // const {body} = document;
        
        data = resultsArray.data[myDate.getUTCDate()-1].timings;

        e1.textContent = data.Imsak;
        e2.textContent = data.Fajr;
        e3.textContent = data.Sunrise;
        e4.textContent = data.Dhuhr;
        e5.textContent = data.Asr;
        e6.textContent = data.Sunset;
        e7.textContent = data.Maghrib;
        e8.textContent = data.Isha;
        
    }
    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    
    // athan api..........
    // navigator.geolocation.getCurrentPosition(success, error);
    getTime();
}